import { dxtToLocalServerTime } from "@dexteel/mesf-core";

export const manualStrandLossDeleteMessage = (start: Date) =>
  `The Strand Loss at ${dxtToLocalServerTime(start, "HH:mm:ss")} will be deleted. Do you want to continue?`;
